import PATH from "constants/path";

import PageNotFound from "./views/PageNotFound";
import SorryPage from "./views/SorryPage";
import Company from "./views/Company";
import First from "./views/First";
import Point from "./views/Point";
import Guide from "./views/Guide";

import News from "features/News";
import Contact from "features/Contact";
import Place from "features/Place";

import Questions from "features/Questions/pages";

import Top from "features/Top/pages";
import Setting from "features/Setting";
import MyPoint from "features/MyPoint/pages";
import Payment from "features/Payment/pages";
import Entries from "features/Entries/pages";
import Promotion from "features/Promotion/pages";

var routes = [
  // PUBLIC ROUTES
  {
    path: PATH.TOP,
    name: "Top",
    exact: true,
    component: Top,
  },
  {
    path: [PATH.PROMOTION, PATH.DETAIL_PROMOTION],
    name: "Promotion",
    exact: true,
    component: Promotion,
  },
  {
    path: PATH.FIRST,
    name: "First",
    exact: true,
    private: false,
    component: First,
  },
  {
    path: PATH.GUIDE,
    name: "Guide",
    exact: true,
    private: false,
    component: Guide,
  },
  {
    path: PATH.COMPANY,
    exact: true,
    name: "Company",
    private: false,
    component: Company,
  },
  {
    path: PATH.POINT,
    exact: true,
    name: "Point",
    private: false,
    component: Point,
  },
  {
    path: PATH.QUESTIONS,
    exact: true,
    name: "Questions",
    private: false,
    component: Questions,
  },
  {
    path: PATH.CONTACT,
    name: "Contact",
    private: false,
    component: Contact,
  },
  {
    path: PATH.AREA_LIST,
    name: "Place",
    private: false,
    component: Place,
  },
  {
    path: PATH.NEWS,
    name: "News",
    private: false,
    component: News,
  },
  {
    path: PATH.SORRY_PAGE,
    name: "SorryPage",
    exact: true,
    private: false,
    component: SorryPage,
  },
  // PRIVATE
  {
    path: PATH.SETTING,
    name: "Setting",
    component: Setting,
    private: true,
  },
  {
    path: PATH.MY_POINT,
    name: "MyPoint",
    exact: true,
    component: MyPoint,
    private: true,
  },
  {
    path: PATH.PAYMENT,
    name: "Payment",
    exact: true,
    component: Payment,
    private: true,
  },
  {
    path: PATH.ENTRIES,
    exact: true,
    name: "Entries",
    component: Entries,
    private: true,
  },
  {
    path: "*",
    name: "PageNotFound",
    component: PageNotFound,
  },
];
export default routes;
